import React from 'react';
import LessonPlansRouter from '../components/LessonPlans/LessonPlansRouter';

const LessonPlansPage = () => {
  return <LessonPlansRouter />;
};

export default LessonPlansPage;
